import { render, staticRenderFns } from "./VerRecibo.vue?vue&type=template&id=2411d002"
import script from "./VerRecibo.vue?vue&type=script&lang=js"
export * from "./VerRecibo.vue?vue&type=script&lang=js"
import style0 from "./VerRecibo.vue?vue&type=style&index=0&id=2411d002&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports